import { useEffect } from 'react';
import { sidebarKeys } from '../Sidebar/sidebarMenuItems';
import { Link, useLocation } from 'react-router-dom';
import { DASHBOARD_URL } from '@src/constants/URLS.const';
import { useExtractPageTitle } from '@src/hooks';

export function Title() {
    const { getSectionTitle } = useExtractPageTitle();
    const { setPageTitle } = useExtractPageTitle();
    const { pathname } = useLocation();

    useEffect(() => {
        // Handle cart route separately
        if (pathname === '/dashboard/cart') {
            setPageTitle('cart');
            return;
        }

        // Handle other routes using sidebarKeys
        Object.keys(sidebarKeys).some((key: string) => {
            if (sidebarKeys[key].URL === pathname) {
                setPageTitle(sidebarKeys[key].key);
                return;
            } else if (
                !sidebarKeys[key].items &&
                DASHBOARD_URL + '/' + sidebarKeys[key].URL === pathname
            ) {
                setPageTitle(sidebarKeys[key].key);
                return;
            } else if (sidebarKeys[key].items) {
                Object.keys(sidebarKeys[key].items).some((itemKey) => {
                    if (
                        DASHBOARD_URL +
                            '/' +
                            sidebarKeys[key].items[itemKey].URL ===
                        pathname
                    ) {
                        setPageTitle(sidebarKeys[key].items[itemKey].key);
                        return;
                    }
                });
            }
        });
    }, [pathname]);

    return (
        <div className="flex flex-row justify-between items-center mt-7 max-xsm:mt-6  px-2 max-msm:px-4  ">
            <p className="sm:text-[22px] text-2xl max-msm:text-lg font-bold text-secondary">
                {getSectionTitle()}
            </p>
        </div>
    );
}
